// Auto generated file, do not manually modify!
// com.hotpads.capps.handler.web.renter.v1.CappsResidenceWebApiHandler

import { getClient } from '../../client';
import { httpFrontEndRequest } from '@zg-rentals/ts-client-http-client';

import type { ValidateResidenceZipcodeWebApiResponseDto } from '../..';

interface ValidateZipcodeParams {
  zipcode: string;
}

export const CappsResidenceWebApiHandler_validateZipcode_Path = '/api/web/renter/v1/residence/validateZipcode';

export const CappsResidenceWebApiHandler_validateZipcode = (getParams: ValidateZipcodeParams, client = getClient()) => {
  return httpFrontEndRequest<ValidateZipcodeParams, never, ValidateResidenceZipcodeWebApiResponseDto>(
    {
      getParams: getParams,
      endpoint: CappsResidenceWebApiHandler_validateZipcode_Path,
      method: 'GET',
      contextPath: '/capps',
    },
    client,
  );
};
